import {
  TEMPLATE_LANGUAGE,
  TEMPLATE_LANGUAGE_LABEL,
  TEMPLATE_STATUS,
} from '../constants/messageTemplateKeys';

const EDITABLE_STATUSES = [TEMPLATE_STATUS.DRAFT, TEMPLATE_STATUS.INACTIVE];

export function isLanguageEditable({ isEditMode = false, currentStatus = null } = {}) {
  if (!isEditMode) return true;
  return EDITABLE_STATUSES.includes(String(currentStatus ?? ''));
}

export function normalizeLanguage(value) {
  const language = String(value ?? '').trim();
  return language.length > 0 ? language : TEMPLATE_LANGUAGE.ENGLISH;
}

export function buildLanguageOptions({ additionalLanguages = [], currentLanguage = null } = {}) {
  const values = [
    TEMPLATE_LANGUAGE.ENGLISH,
    ...(additionalLanguages ?? []).map(String),
    ...(currentLanguage ? [String(currentLanguage)] : []),
  ];

  return [...new Set(values)]
    .filter((value) => TEMPLATE_LANGUAGE_LABEL[value])
    .map((value) => ({ value, label: TEMPLATE_LANGUAGE_LABEL[value] }));
}

// English is always implied, so a tenant only has a choice once it has enabled something
// beyond it.
export function tenantHasLanguageChoice(additionalLanguages = []) {
  return (additionalLanguages ?? [])
    .map(String)
    .some(
      (value) => value !== TEMPLATE_LANGUAGE.ENGLISH && Boolean(TEMPLATE_LANGUAGE_LABEL[value]),
    );
}
